/** The signed-in user's own Profile page. */
export default {
    profile: {
        title: 'Profile',
        account: 'Account',
        roles: 'Roles',
        activeWebsite: 'Active website',
    },
    language: {
        title: 'Language',
        label: 'Admin language',
        hint: 'The language you see the admin in. It follows you to every device you sign in on.',
        browser: 'Same as this browser ({language})',
        saved: 'Language saved',
    },
    passkeys: {
        title: 'Passkeys',
        intro: "Passkeys let you sign in without a password: your device (or a hardware key) proves it's you. You can register multiple keys (laptop biometric + phone + a backup hardware key) and use any of them.",
        unsupported: 'This browser does not support passkeys.',
        label: 'Label',
        labelPlaceholder: 'e.g. iPhone, work laptop',
        register: 'Register passkey',
        registerFailed: 'Could not register passkey.',
        empty: 'No passkeys yet. Register one above to start signing in without a password.',
        usage: 'Added {added} · Last used {used}',
        remove: 'Remove passkey',
        confirmRemove: 'Remove passkey "{label}"? You won\'t be able to use it to sign in anymore.',
        defaultLabel: '{device} passkey',
        defaultLabelGeneric: 'Passkey',
    },
};
